import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useSailorSubmitForChecks = (applicationId) => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "sailorSubmitForChecks"
  );
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [applicationId]);
  const sailorSubmitForChecks = async () => {
    try {
      const result = await executeCallable({ applicationId });
      if (result?.data?.success) {
        setComplete(true);
        return true;
      } else {
        setComplete(false);
        return false;
      }
    } catch (err) {
      setComplete(false);
      return false;
    }
  };
  return {
    saving,
    error,
    success: !saving && !error && complete,
    sailorSubmitForChecks,
  };
};
